module.exports = __webpack_public_path__ + "media/images/plans/plan-detail-icon-accessories-f193adc3c015ec4687eda05184d675e1.png";